import { initiateLogin } from '../lib/auth';

export default function LoginPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Job App</h1>
        <p className="text-gray-600 mb-6">
          AI-powered job application management
        </p>
        <button
          onClick={initiateLogin}
          className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
        >
          Sign in with Cognito
        </button>
        <p className="mt-4 text-xs text-gray-500">
          Secure authentication via AWS Cognito (PKCE)
        </p>
      </div>
    </div>
  );
}
